import React from 'react';
import { Navigate } from 'react-router-dom';
import { isAuthenticated, getUserRole } from './auth';
import { useSelector } from 'react-redux';

const ProtectedRoute = ({ children, allowedRoles, checkSubscription }) => {
    const isAuth = isAuthenticated();
    const userRole = getUserRole();
    const user = useSelector(state => state?.AuthSlice?.user)

    console.log(user);

    if (isAuth && !allowedRoles) {
        const redirectPath =
            userRole === 'corporate' ? '/corporate/dashboard' :
                userRole === 'professional' ? '/professional/services' :
                    userRole === 'user' ? '/user/chat' : !userRole ? "/signin" : '/';

        // console.log(redirectPath, "p2");

        return <Navigate to={redirectPath} />;
    }

    console.log("!isAuth", !isAuth);
    console.log(("!allowedRoles?.includes(userRole)"), !allowedRoles?.includes(userRole));


    // Redirect unauthorized users
    if (!isAuth || !allowedRoles?.includes(userRole)) {
        // console.log("here is test pro");

        return <Navigate to="/unauthorized" />;

    }

    if (checkSubscription && (!user?.subscription || user.subscription.status !== "active" && user?.subscription?.status !== 'cancelled')) {
        const redirectPath = {
            corporate: '/corporate/subscriptions',
            professional: '/professional/subscriptions',
            user: '/user/subscriptions',
        }[userRole] || '/';

        return <Navigate to={redirectPath} />;
    }

    return children;
};


export default ProtectedRoute;
